// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-color[data-v-3c64da38]{color:#4abca5}.toolbar-color[data-v-3c64da38]{background-color:rgba(131,125,137,.35)}", ""]);
// Exports
module.exports = exports;
